
define( 'system/js/socket',[ 'jclass', 'socketio' ], function( Class, io ) {
	'use strict';

	/*
	===============================================================================
	Class: Socket
	===============================================================================
	*/

	var Socket = Class._extend( {

		/**
		 * Method: init
		 * @param {Object} aOptions
		 */

		init: function( aOptions ) {
			var options = aOptions || { };

			this._parent = options.parent;
			this._session_id = options.session_id;
			this._url = options.url;
			this._connection = null;
			this._once = { };
		},

		/**
		 * Method: getParent
		 */

		getParent: function( ) {
			return this._parent;
		},

		/**
		 * Method: connect
		 */

		connect: function( ) {
			this._connection = io( this._url, {
				transports: [ 'websocket', 'xhr-polling' ],
				path: '/'
			} );

			return this;
		},

		/**
		 * Method: getConnection
		 */

		getConnection: function( ) {
			if ( this._connection === null ) {
				this.connect( );
			}

			return this._connection;
		},

		/**
		 * Method: disconnect
		 */

		disconnect: function( ) {
			if ( this._connection !== null ) {
				this.broadcast( 'disconnecting' );

				this._connection.close( );
				this._connection = null;
			}

			return this;
		},

		/**
		 * Method: authenticate
		 */

		authenticate: function( aOptions ) {
			var options = aOptions || { };

			options = $.extend( { }, options, {
				session_id: this._session_id
			} );

			this.broadcast( 'authenticate', options );

			return this;
		},

		/**
		 * Method: on
		 * @param {String} aEvent
		 * @param {Function} aCallback
		 */

		on: function( aEvent, aCallback ) {
			var self = this;

			this._connection.on( aEvent, function( aData ) {
				var data = aData || { },
					ignore = false,
					once_composite;

				// Check if this event is both a broadcast and designed to ignore this socket
				if ( aEvent === 'broadcast' && data.hasOwnProperty( 'ignore' ) === true && data.ignore === this.id ) {
					ignore = true;
				}
				// Check for 'once', which is a flag to not show it more than once for the current room (until the page is refreshed)
				else if ( data.hasOwnProperty( 'once' ) === true ) {
					once_composite = data.once + '_' + data.event;

					// Check if this has already occurred in this room
					if ( self._once.hasOwnProperty( once_composite ) === true ) {
						// Ignore it, second or subsequent time
						ignore = true;
					}
					else {
						self._once[ once_composite ] = true;
					}
				}

				if ( ignore === false ) {
					aCallback( data );
				}
			} );

			return this;
		},

		one: function( aEvent, aCallback ) {
			this._connection.once( aEvent, function( aData ) {
				aCallback( aData );
			} );
		},

		/**
		 * Method: broadcast
		 * @param {String} aEvent
		 * @param {Object} aData
		 */

		broadcast: function( aEvent, aData ) {
			var data = aData || { };

			this._connection.emit( aEvent, data );

			return this;
		},

		/**
		 * Method: join
		 * @param {Array} aRooms
		 */

		join: function( aRooms ) {
			var rooms = aRooms || [ ],
				i, len;

			// TODO the join all functionality is a bit contrived for normal usage and can be taken out after stresstesting
			if ( rooms.length > 0 ) {
				for ( i = 0, len = rooms.length; i < len; i++ ) {
					this.broadcast( 'join', { room: rooms[ i ].name } );
				}
			}
			else {
				this.broadcast( 'join', { } );
			}
		},

		/**
		 * Method: sesSessionId
		 * @param {String} aSessionId
		 */

		setSessionId: function( aSessionId ) {
			this._session_id = aSessionId;
		}
	} );

	return Socket;
} );

